import { render, staticRenderFns } from "./CreateWF.vue?vue&type=template&id=6556ebe6&"
import script from "./CreateWF.vue?vue&type=script&lang=js&"
export * from "./CreateWF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports